<div class="row">
  <div class="col-lg-4 col-xl-3 mb-4">
    <div class="checklist-sticky">
      <div class="card mb-3">
        <div class="card-body">
          <div class="subhead-1">Machine</div>
          <div class="font-weight-light">{{ inspection.inventoryItem.year }} {{ inspection.inventoryItem.make }} {{ inspection.inventoryItem.model }}</div>
          <div class="font-weight-light">SN: {{ inspection.inventoryItem.serialNumber }}</div>
          <div class="subhead-1 mt-2">Inspection Report</div>
          <div class="font-weight-light">{{ inspection.inspectionType }}</div>
          <div class="font-weight-light">{{ inspection.createdDateTime | date: "short" }}</div>

          <ng-container *ngIf="inspection.user">
            <div class="subhead-1 mt-2">Inspector</div>
            <div class="font-weight-light">{{ inspection.user.name }}</div>
            <div class="font-weight-light">{{ inspection.user.email }}</div>
            <div class="font-weight-light">{{ inspection.user.phoneNumber }}</div>
          </ng-container>
        </div>
      </div>
      <ul class="list-group">
        <li
          class="list-group-item d-flex align-items-center cursor-pointer"
          *ngFor="let section of inspection.sections; index as i"
          [routerLink]="'.'"
          [fragment]="'section-' + section.title"
          [attr.rt]="'checklist-section-' + i"
          href="#section-{{ section.title }}"
        >
          <span class="mr-1" *ngIf="!section.complete">{{ i + 1 }}.</span>
          <i class="icon-check-circle-fill text-green fs-22 mr-2" *ngIf="section.complete"></i>
          {{ section.title || "General Info" }}
          <i class="ml-auto icon-notification1 text-primary fs-20" *ngIf="section.hasFailures"></i>
        </li>
      </ul>
    </div>
  </div>
  <div class="col-lg-8 col-xl-9">
    <section class="mb-4" *ngFor="let section of inspection.sections" id="section-{{ section.title }}">
      <div class="card">
        <h4 class="card-header d-flex align-items-center" *ngIf="section.title">
          {{ section.title }} <i class="ml-2 icon-notification1 text-primary" *ngIf="section.hasFailures"></i>
        </h4>
        <div class="card-body">
          <div class="row">
            <ng-container *ngFor="let step of section.steps">
              <ng-container *ngFor="let input of step.inputs">
                <div class="col-md-6 mb-4" *ngIf="input.inputType === 'Photo' && input.mediaPath">
                  <div>{{ step.title }}</div>
                  <div class="font-weight-light fs-14">{{ input.instruction }}</div>
                  <a target="_blank" [href]="baseImagePath + '/' + input.mediaPath"
                    ><img *ngIf="input.inputType === 'Photo'" class="img-fluid" [src]="baseImagePath + '/' + input.mediaPath"
                  /></a>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <div class="row">
            <ng-container *ngFor="let step of section.steps; last as isLast">
              <div class="col-md-6 pr-lg-5" *ngIf="!step.hide">
                <ng-container [ngSwitch]="step.stepType">
                  <ng-container *ngSwitchCase="'BoolStep'" class="d-flex">
                    <div class="d-flex align-items-center">
                      <div class="mr-auto w-75">
                        {{ step.title }}
                      </div>
                      <div *ngIf="step.answer">{{ step.answer }} **answer</div>
                      <div *ngIf="step.value">
                        <i [ngClass]="{ 'icon-checkmark text-green': step.value == 'True', 'icon-close text-red': step.value != 'True' }" class="mr-2 fs-18"></i
                        >{{ step.value == "True" ? step.positiveLabel : step.negativeLabel }}
                      </div>
                    </div>
                    <div [class.mb-4]="!step.hasNotes" class="font-weight-light fs-14 w-75">
                      {{ step.helpText }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'DataCollection'">
                    <!--  need to update this here. -->
                    <div>{{ step.title }}</div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'MultiAcknowledgementStep'">
                    <p class="section-header">{{ step.title }}</p>
                    <p>{{ step.helpText }}</p>
                    <ng-container *ngFor="let ack of step.acknowledgements">
                      <p class="text-grey paragraph-text">{{ ack.description }}</p>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <p class="section-header">{{ step.title }}</p>
                    <p>{{ step.helpText }}</p>
                  </ng-container>
                </ng-container>
                <!-- have all other non photo inputs last  -->
                <ng-container *ngFor="let input of step.inputs">
                  <ng-container *ngIf="input.inputType !== 'Photo'">
                    <div
                      class="mb-3"
                      [ngClass]="{ 'mb-4 fs-15': step.hasNotes && step.stepType == 'BoolStep' }"
                      *ngIf="input.value"
                      [class.fs-15]="step.stepType == 'DataCollection'"
                    >
                      <div class="mr-auto">{{ input.instruction }}</div>
                      <div class="" [class.font-weight-light]="step.stepType == 'DataCollection'">
                        <div class="font-weight-light fs-14" *ngIf="!input.items.length">{{ input.value }}</div>
                        <div class="font-weight-light fs-14" *ngIf="input.items.length">{{ input.items[0].value }}</div>
                      </div>
                    </div>
                    <ng-container *ngIf="input.mediaPath">
                      <p>
                        {{ input.instruction
                        }}<span *ngIf="input.inputType === 'Video'"> - <a [href]="baseImagePath + '/' + input.mediaPath">Download Video</a></span>
                      </p>
                      <video *ngIf="input.inputType === 'Video'" class="w-100" [src]="baseImagePath + '/' + input.mediaPath" controls></video>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
